const states = {
  Draft: "states.Draft",
  Submitted: "states.Submitted",
  Rejected: "states.Rejected",
  Approved: "states.Approved",
} as const;
const decisions = {
  Pending: "decisions.Pending",
  Approved: "decisions.Approved",
  Rejected: "decisions.Rejected",
} as const;
const events = {
  create: "events.create",
  edit: "events.edit",
  submit: "events.submit",
  approve: "events.approve",
  reject: "events.reject",
  assign: "events.assign",
  reassign: "events.reassign",
  "replace-approver": "events.replace-approver",
} as const;
function key<T extends Record<string, string>>(
  map: T,
  value: string,
): T[keyof T] | "unknownState" {
  return Object.hasOwn(map, value) ? map[value as keyof T] : "unknownState";
}
export const requestStateKey = (value: string) => key(states, value);
export const requestDecisionKey = (value: string) => key(decisions, value);
export const requestEventKey = (value: string) => key(events, value);
